import {t, useLanguage} from '../i18n';
import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import SearchSuggestions from '../SearchSuggestions';
import { businessPublicPath } from '../utils/businessSlug';
import '../styles/searchExperience.css';

export default function MarketplaceSearch({ value, onChange, onSearch, db }) {
  useLanguage();
  const [open, setOpen] = useState(false);
  const root = useRef(null);
  const input = useRef(null);
  const navigate = useNavigate();
  useEffect(() => {
    const outside = e => { if (!root.current?.contains(e.target)) setOpen(false); };
    document.addEventListener('pointerdown', outside);
    return () => document.removeEventListener('pointerdown', outside);
  }, []);
  useEffect(() => {
    if (!open || !window.matchMedia('(max-width: 600px)').matches) return;
    const previous = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = previous; };
  }, [open]);
  const search = term => {
    const clean = String(term || '').trim();
    if (!clean) return;
    try {
      const old = JSON.parse(localStorage.getItem('loop_search_recents_v2') || '[]');
      localStorage.setItem('loop_search_recents_v2', JSON.stringify([clean, ...old.filter(x => x !== clean)].slice(0, 5)));
    } catch (_) {}
    setOpen(false);
    onSearch(clean);
  };
  return <div ref={root} className={`marketplace-search ${open ? 'is-open' : ''}`} onKeyDown={e => {
    if (e.key === 'Escape') { input.current?.focus(); setOpen(false); }
    if (e.key === 'ArrowDown' && e.target === input.current) { e.preventDefault(); root.current.querySelector('.loop-warm-row')?.focus(); }
  }}>
    <form role="search" onSubmit={e => { e.preventDefault(); search(value); }}>
      <span aria-hidden="true" className="marketplace-search-icon">⌕</span>
      <input ref={input} type="search" aria-label={t("Busca un servicio o negocio")} aria-expanded={open} autoComplete="off" placeholder={t("Busca un servicio o negocio")} enterKeyHint="search" value={value || ''} onFocus={() => setOpen(true)} onChange={e => { onChange(e.target.value); setOpen(true); }} />
      <button type="submit" className="marketplace-search-submit">{t("Buscar")}</button>
      {open && <button className="marketplace-search-cancel" type="button" onClick={() => { setOpen(false); input.current?.blur(); }}>{t("Cancelar")}</button>}
    </form>
    {open && <div className="marketplace-search-panel"><SearchSuggestions db={db} q={value} onSelectService={search} onSelectBusiness={biz => { setOpen(false); navigate(businessPublicPath(biz)); }} /></div>}
  </div>;
}
